import { object } from "valibot";
import type ServiceAccountId from "../state/ServiceAccountId";
import { requireText } from "../utils/validation/base";
import { MAX_CHARACTERS_SM } from "../constants";

export type ServiceAccountType = "ONEDRIVE" | "GOOGLE_SHEETS";
export type ServiceAccountState = "VALID" | "INVALID" | "EXPIRED" | "UNKNOWN";
export type ServiceAccount = {
  id: ServiceAccountId;
  type: ServiceAccountType;
  name?: string;
  identifier?: string;
  meta: {
    createdOn: Date;
  };
};

export const renameServiceAccountSchema = object({
  name: requireText(MAX_CHARACTERS_SM),
});
